{
    "filter_menu_title__status": "Status",
    "filter_menu_title__order_date": "Auftragsdatum",
    "filter_menu_title__quote_date": "Angebotsdatum",
    "filter_menu_title__clerk": "Erfasst von",
    "filter_menu_title__order_type": "Auftragsart",
    "filter_menu_title__quote_type": "Angebotsart",
    "filter_menu_title__sales_rep": "Vertreter",
    "filter_menu_title__location": "Lager",
    "filter_menu_title__total_amount_net": "Summe",
    "filter_menu_title__total_margin": "Deckungsbeitrag",
    "table_header__product_name": "Artikel",
    "table_header__quote_id": "Angebots-Nr.",
    "table_header__order_id": "Auftrags-Nr.",
    "table_header__order_type": "Auftragsart",
    "table_header__quote_type": "Angebotsart",
    "table_header__customer_id": "Kunden-Nr.",
    "table_header__customer": "Kunde",
    "table_header__quote_created": "Datum",
    "table_header__order_created": "Datum",
    "table_header__status": "Status",
    "table_header__quantity": "Menge geliefert",
    "table_header__quantity_short": "Menge",
    "table_header__total": "Summe",
    "table_header__rebate": "Rabatt",
    "table_header__margin": "DB",
    "table_header__margin_percent": "DB %",
    "table_header__price": "Preis",
    "table_header__lines": "Positionen",
    "table_header__clerk": "Erfasser",
    "table_header__po_number": "Kommission",
    "search_placeholder__orders": "Suche nach Kunde, Auftrag, Kommission",
    "search_placeholder__quotes": "Suche nach Kunde, Angebot, Kommission",
    "table_footer__sum": "Summe"
}
